import * as yup from "yup"
import dayjs from "dayjs"
import { IntlShape } from "react-intl"

declare module "yup" {
    interface MixedSchema {
        isValidDayjs(msg: string): this
        isFutureDayjs(msg: string): this
    }
}

const useCustomYupValidationMethods = () => {
    // Define a custom validation method for dayjs date
    yup.addMethod(yup.mixed<dayjs.Dayjs>, "isValidDayjs", function (msg: string) {
        return this.test("dayjsDate", msg, function (value) {
            if (!value) return true // Allow empty values
            return dayjs(value).isValid()
        })
    })
    yup.addMethod(yup.mixed<dayjs.Dayjs>, "isFutureDayjs", function (msg: string) {
        return this.test("dayjsDate", msg, function (value) {
            if (!value) return true // Allow empty values
            return dayjs(value).isValid() && dayjs(value) >= dayjs().startOf("day")
        })
    })
}
export default { useCustomYupValidationMethods, yup }

export const emptyOrPositiveNumberValidator = (intl: IntlShape) =>
    yup
        .number()
        .transform(function (value, originalValue) {
            if (this.isType(value)) return value
            if (!originalValue || !originalValue.trim()) {
                return null
            }
            return originalValue
        })
        .nullable()
        .typeError(intl.formatMessage({ id: "validations.format-error" }))
        .test("positive", intl.formatMessage({ id: "validations.positive-numbers" }), (value) => {
            const num = Number(value)
            return !value || num > 0
        })

export const positiveNumberValidator = (intl: IntlShape) =>
    yup
        .number()
        .required(intl.formatMessage({ id: "validations.required" }))
        .test("positive", intl.formatMessage({ id: "validations.positive-numbers" }), (value) => {
            const num = Number(value)
            return !!value && num > 0
        })

export const zeroAndpositiveNumberValidator = (intl: IntlShape) =>
    yup
        .number()
        .required(intl.formatMessage({ id: "validations.required" }))
        .test("positive-and-zero", intl.formatMessage({ id: "validations.positive-numbers" }), (value) => {
            const num = Number(value)
            return value !== undefined && value !== null && num >= 0
        })

export const nonZeroNumberValidator = (intl: IntlShape) =>
    yup
        .number()
        .required(intl.formatMessage({ id: "validations.required" }))
        .test("non-zero", intl.formatMessage({ id: "validations.required" }), (value) => {
            const num = Number(value)
            return !!value && num !== 0
        })

export const emptyOrFutureDateValidator = (intl: IntlShape) =>
    yup
        .mixed<dayjs.Dayjs>()
        .isValidDayjs(intl.formatMessage({ id: "validations.format-error" }))
        .isFutureDayjs(intl.formatMessage({ id: "validations.future-date" }))
